import React, { useState, useContext } from 'react';
import styles from './NewFriendModal.module.sass';
import Modal from '../../../components/Modal';
import TextInput from '../../../components/TextInput';
import Loader from '../../../components/LoaderCircle';
import { ConquerContext } from '../../../contexts/ConquerContext';

const NewFriendModal = ({ onFriendAdded }) => {

    const conquer = useContext( ConquerContext );

    const [avatarID, setAvatarID] = useState( '' );
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    function showError(message) {
        setError(message);
        return false;
    }

    async function tryToAddFriend() {
        // if (!/\S+@\S+\.\S+/.test(email)) return showError('The email doesnt have a valid format');
        if (!conquer.instance || !conquer.isInitialized) return showError('There was an error when connecting to our servers. Please try again.');

        setIsLoading(true);
        let response = await conquer.instance.Friends.set(avatarID);
        console.log( response );
        setIsLoading(false);

        if (response.error || !response.avatarID) return showError(response.error || 'The user doesnt exists');

        onFriendAdded?.();
        setIsVisible( false );

    }

    return (
        <>
            <button
                className={'button-small'}
                onClick={() => {
                    setIsVisible(true);
                }}>
                Add Friend
            </button>
            <Modal
                visible={isVisible}
                onClose={() => {
                    setIsVisible(false);
                }}
                title='Add Friend'>
                <div className={styles.container}>
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <>
                            <TextInput
                                className={styles.field}
                                type='text'
                                placeholder='Avatar ID'
                                onChange={(event) => { setAvatarID(event.target.value) }}
                            />
                            <button className='button' onClick={tryToAddFriend}>
                                Send Invitation
                            </button>
                            {error && <p style={{ color: "red", maxWidth: '75%', textAlign: 'center' }}>{error}</p>}
                        </>
                    )}
                </div>
            </Modal>
        </>
    );
};

export default NewFriendModal;
